import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    imports: [RouterOutlet],
})
export class AppComponent {
  title = 'KisPortas-Admin';

  constructor() {
    this.setTheme();
  }

  private async setTheme(): Promise<void> {
    let storedTheme = 'dark';
    let isDarkMode = storedTheme
      ? storedTheme === 'dark'
      : window.matchMedia('(prefers-color-scheme: dark)').matches;

    document.body.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }
}
